import mixins from 'vue-typed-mixins';

import { BannerInterface } from '@/interfaces/BannerInterface';
import bannerService from '@/services/banner-service';
import { BannerType } from '@/shared/enums/BannerType';
import { Target } from '@/shared/enums/Target';

export const banner = mixins().extend({
	data() {
		return {
			Target,
			banner: {} as BannerInterface,
		};
	},
	computed: {
		isBannerPending(): boolean {
			return bannerService.isPending;
		},
		isBannerOfferPending(): boolean {
			return bannerService.isPendingOffer;
		},
		isBannerPromoPending(): boolean {
			return bannerService.isPendingPromo;
		},
		isBannerHBOPending(): boolean {
			return bannerService.isPendingHBO;
		},
		isAllBannersPending(): boolean {
			return this.isBannerPending || this.isBannerOfferPending;
		},
		isBannerLoaded(): boolean {
			return bannerService.isLoaded;
		}
	},
	methods: {
		getBanner(bannerType: BannerType | null, skipLoader = true): Promise<BannerInterface> {
			if (!bannerType) return Promise.resolve(this.banner);

			return bannerService.getBanners([ bannerType ], skipLoader)
				.then(banners => {
					this.banner = banners[bannerType];
					return banners[bannerType];
				});
		},
		getLoginBanner(): void {
			bannerService.getLoginBanner().then((banner: BannerInterface) => this.banner = banner);
		}
	},
});
